export enum StreamChatCommunityChannelTypesEnum {
	Announcements = 'announcements',
	General = 'general',
	IntroduceYourself = 'introduce-yourself',
	PhotoShares = 'photo-shares',
	CustomChat = 'custom-chat',
	EventChat = 'event-chat',
	MembershipChat = 'membership-chat',
	ChallengeChat = 'challenge-chat',
}
